// ColorTextField accepts CSS hex RGB/RGBA in both short and long forms.
// A transparency key matches RGB; an optional alpha suffix does not affect it.
export const parseTransparencyColor = color => {
  if (typeof color !== 'string' || !/^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)) {
    return null;
  }
  const hex = color.slice(1);
  const rgb = hex.length <= 4
    ? [...hex.slice(0, 3)].map(digit => digit + digit).join('')
    : hex.slice(0, 6);
  return [0, 2, 4].map(offset => parseInt(rgb.slice(offset, offset + 2), 16));
};
